import React, { type FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../EditPasswordForm/EditPasswordForm.module.scss';
import TextField from '../form-fields/TextField/TextField';
import Button from '../Button/Button';

const EditPasswordCodeForm = ({ email, onSubmit }: { email: string; onSubmit: (code: string) => void }) => {
  const { t } = useTranslation('account');
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (event: FormEvent) => {
    setError(!code);

    if (code) {
      event.preventDefault();
      onSubmit(code);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2 className={styles.title}>{t('reset.password_reset')}</h2>
      <p>{t('reset.token_instructions', { email })}</p>
      <TextField
        className={styles.textField}
        value={code}
        onChange={(event) => setCode(event.currentTarget.value)}
        error={error}
        label={t('reset.reset_password_token')}
        name="resetPasswordToken"
        type="text"
        autoComplete=""
        required
      />
      <Button type="submit" className={styles.button} fullWidth color="primary" label={t('reset.confirm')} />
    </form>
  );
};

export default EditPasswordCodeForm;
